import { render } from "./FollowMarketingLogsPanel.vue?vue&type=template&id=3c14e9a4&scoped=true"
import script from "./FollowMarketingLogsPanel.vue?vue&type=script&lang=js"
export * from "./FollowMarketingLogsPanel.vue?vue&type=script&lang=js"

import "./FollowMarketingLogsPanel.vue?vue&type=style&index=0&id=3c14e9a4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c14e9a4"]])

export default __exports__